import posthog from "posthog-js";
import { useEffect, useLayoutEffect } from "react";

import { fetchWalletStats } from "../utils/walletStats";
import { useWallet } from "../wallet/hooks/useWallet";

import { isAnalyticsEnabled } from "./posthog";
import { walletJourney } from "./walletJourney";

export function useWalletLifecycleAnalytics(allowed: boolean, checked: boolean, failed: boolean): void {
    const { connected, connecting, publicKey, walletName, isWalletReady } = useWallet();
    const address = connected ? (publicKey?.toString() ?? null) : null;
    useLayoutEffect(() => {
        walletJourney.observe(address, connecting, walletName ?? "unknown");
        if (checked) walletJourney.access(failed ? "error" : allowed ? "granted_public" : "denied", isWalletReady);
    }, [address, connecting, walletName, checked, failed, allowed, isWalletReady]);
    useEffect(() => {
        if (!address || !publicKey || !isAnalyticsEnabled()) return;
        let active = true;
        const owner = walletJourney.owner();
        void fetchWalletStats(publicKey)
            .then((stats) => {
                if (
                    active &&
                    walletJourney.owner().properties.wallet_session_id === owner.properties.wallet_session_id &&
                    isAnalyticsEnabled()
                )
                    posthog.setPersonProperties(stats);
            })
            .catch(() => undefined);
        return (): void => {
            active = false;
        };
    }, [address, publicKey]);
}
